var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSwap = function SvgSwap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.14003 6.85997L0.360029 9.64997C0.170029 9.84997 0.170029 10.16 0.360029 10.36L3.14003 13.15C3.45003 13.47 3.99003 13.24 3.99003 12.8V11H10C10.55 11 11 10.55 11 9.99997C11 9.44997 10.55 8.99997 10 8.99997H3.99003V7.20997C3.99003 6.75997 3.45003 6.53997 3.14003 6.85997ZM17.65 3.64997L14.87 0.859966C14.56 0.539966 14.02 0.769966 14.02 1.20997V2.99997H8.00003C7.45003 2.99997 7.00003 3.44997 7.00003 3.99997C7.00003 4.54997 7.45003 4.99997 8.00003 4.99997H14.01V6.78997C14.01 7.23997 14.55 7.45997 14.86 7.13997L17.64 4.34997C17.84 4.15997 17.84 3.83997 17.65 3.64997Z",
    fill: "currentColor"
  })));
};
export default SvgSwap;